<template>
  <div v-if="signatoriesCount === 1">
    <ProjectSettingsSignaturesSignatory :item="item"
                                        :signatory="signatoriesList[0]"
    />
  </div>
  <div v-else-if="signatoriesCount > 1" class="d-flex align-center column-gap-2">
    <app-material-icon v-if="allSignatorySigned"
      name="schedule"
    />
    <app-material-icon v-else
      name="check_circle"
      color="icon-success"
    />
    <span v-t="{
              path: 'project.project-settings.signatures.ProjectSettingsSignaturesSignatoriesSummary.multipleSignatories',
              plural: signatoriesCount - 1,
              args: {
                signerName: signatoriesList[0].fullName,
                count: signatoriesCount - 1,
              },
            }"
    />
  </div>
</template>

<script>
import ProjectSettingsSignaturesSignatory from './ProjectSettingsSignaturesSignatory.vue'

export default {
  name: 'ProjectSettingsSignaturesSignatoriesSummary',
  components: { ProjectSettingsSignaturesSignatory },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    signatoriesList () {
      if (this.item.envelopeType === 'single') { return this.item.signatories.filter(s => s.signatureType !== 'witness') }

      return [...this.signatoriesCommonList, ...this.signatoriesUniqueList]
    },
    signatoriesCommonList () {
      return this.item.signatories.filter(signatory => !signatory.signers && signatory.signatureType !== 'witness')
    },
    signatoriesCount () {
      return this.signatoriesUniqueList.length + this.signatoriesCommonList.length
    },
    signatoriesUniqueList () {
      return this.item.signatories.find(signatory => signatory.signers)?.signers || []
    },
    allSignatorySigned () {
      return this.signatoriesList.filter(signatory => signatory.status !== 'signed').length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.ProjectSettingsSignatures-listDot {
  background-color: rgb(var(--v-theme-accent));
  border-radius: 50%;
  display: inline-block;
  height: 5px;
  margin-right: 5px;
  vertical-align: middle;
  width: 5px;
}
</style>
